// register component as global
// define component naming with kebab-case
const userProfileCardCmp = Vue.component("userprofile-card-component", {
  template: "#userprofilecardTemplate",
  data: function () {
    return {
      isEnabledKYC: uiConfig.isEnabledKYC,
      isInvitationEnabled:
        companyInfo.isEnableInviteCode &&
        companyInfo.accountInfo.isVIPEnabledInvite,
      userProfileInfo: {
        kycStatus: "uncertified", // ← ADDED: ensure badge shows “KYC” by default
        inviteCode: "",
        creditScore: 100,
        totalAmt: 0.0,
        totalDailyCommissionAmt: 0.0,
        vipLevel: 0,
        vip: {
          pic: "",
        },
        todayResetCount: 0,
        email: "",
        processingAmt: 0.0,
        accumCommission: 0.0,
      },
    };
  },
  computed: {
    /* expose the status we got from the API so the template
      can do  v-if="kycStatus"  */
    kycStatus() {
      return this.userProfileInfo.kycStatus || "uncertified";
    },

    /* used by  :class="['kyc-badge', statusClass]"  */
    statusClass() {
      return (
        {
          pending: "pending",
          approved: "verified",
          verified: "verified",
          rejected: "rejected",
        }[this.kycStatus] || "uncertified"
      );
    },

    /* text that appears inside the span */
    statusText() {
      return (
        {
          pending: "PENDING",
          approved: "VERIFIED",
          verified: "VERIFIED",
          rejected: "FAILED",
          uncertified: "UNCERTIFIED", // ← explicitly handle the “uncertified” state
        }[this.kycStatus] || (this.kycStatus || "").toUpperCase()
      );
    },
  },

  methods: {
    /** navigate to the KYC page (click on the badge) */
    to_kyc() {
      window.location.href = "/index/my/kyc";
    },
  },

  created() {
    var self = this;

    if (companyInfo && companyInfo.accountInfo) {
      this.userProfileInfo.inviteCode = companyInfo.accountInfo.inviteCode;
    }
    if (companyInfo && companyInfo.accountInfo) {
      this.userProfileInfo.email = companyInfo.accountInfo.email;
    }

    axios({
      method: "GET",
      url: "/index/my/userprofilecard",
    }).then(function (response) {
      console.log("/index/my/userprofilecard:", response);
      if (response.data.code === 0) {
        const data = response.data.data;
        self.userProfileInfo = { ...self.userProfileInfo, ...data };
      }
    });
  },
});
